import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SubscriptionService } from '../../+authenticated/+reports/shared/subscriptions/subscription.service';

export const selectedSubscriptionGuard = (() => {
  const subscriptionService = inject(SubscriptionService);
  const router = inject(Router);

  if (subscriptionService.getHasSetValue()) {
    return true;
  }

  return router.createUrlTree(['', { outlets: { modal: null } }]);
}) satisfies CanActivateFn;
